import * as React from 'react'
import { AuthContext } from 'contexts'

export const useAuth = () => {
  const auth = React.useContext(AuthContext)
  return auth
}
